import { useCallback, useEffect, useState } from "react";
import debounce from "lodash/debounce";

const DEFAULT_WAIT = 300;
const MOBILE_BREAKPOINT = 768;

export default function useWindowSize({ wait = DEFAULT_WAIT } = {}) {
  // Initialize state with undefined width/height so server and client renders match
  const [windowSize, setWindowSize] = useState({
    height: typeof window !== "undefined" ? window.innerHeight : undefined,
    isMobile:
      typeof window !== "undefined"
        ? window.innerWidth < MOBILE_BREAKPOINT
        : undefined,
    width: typeof window !== "undefined" ? window.innerWidth : undefined,
  });

  const handleResize = useCallback(
    debounce(() => {
      if (
        window.innerWidth !== windowSize.width ||
        window.innerHeight !== windowSize.height
      ) {
        setWindowSize({
          height: window.innerHeight,
          isMobile: window.innerWidth < MOBILE_BREAKPOINT,
          width: window.innerWidth,
        });
      }
    }, wait),
    [wait]
  );

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
      handleResize.cancel();
    };
  }, [handleResize]);

  return windowSize;
}
